export const hengenixPatientPhoto = '560c78af-a451-4a60-ba95-6ff656090100'
export const anonymousListingPagePhoto = '3c7bd0ef-d9a1-4e51-29cc-13fd119d2800'
